import type { FaireProductEntity } from "../../entity_types/product";

export const p_pph29p7gx3: FaireProductEntity = {
  token: "p_pph29p7gx3",
  type: "product",
  name: "Christmas Grinch  minis glow in the dark",
  brandToken: "b_gcd5wc4rkp",
  brandName: "Treat Yourself Boutiques",
  imageUrl:
    "https://cdn.faire.com/fastly/69584403b2924c75b17bedf62986bbbc0f2ba66bf245dd0f1c02f469d154007e.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.25,
  description:
    "Grinch Dumplings are great for all ages, comes with steamer basket\nGlow in the dark \n**NOT BRANDED**\ncolors may vary\n\n\n\n**please be sure when ordering, as we do not cancel orders due to this negatively affecting our analytics here on the platform*",
  tags: [],
  msrpDollars: 10.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:14.864Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
